import etherollAbi from './etheroll-abi';
import { fromWei, toWei, toBN, BN, } from 'web3-utils';

var BigInteger = require("big-integer");
// TODO require vs import
// const SolidityEvent = require('web3/lib/web3/event.js');

const Networks = Object.freeze({ mainnet: 1, kovan: 42, bsctest: 97, bsc: 56 });

const contractAddresses = {
  [Networks.mainnet]: '0xd786646ebDF043309a880b6f2352f7399982F9e9',
  [Networks.kovan]: '0xFeFD3AFb803457F3700c631e7E67a17347Ef8717',
  [Networks.bsctest]: '0x1c42b26Ecac6ab36C12ff5D67c89706dF8111694',
  [Networks.bsc]: '0xB0F83fe3Ca5Ce287A8473fadf37954587070F18c',
};
const factoryAddresses = {
  [Networks.mainnet]: '0x4E0039f9b217816A80D1466a99eeB0D7cb91744f',
  [Networks.kovan]: '0x6aE92baB5f1bb69b2B84F52233eF8b326Bbd031C',
  [Networks.bsctest]: '0x7bE3bC570497B9109874c164c7457D5859322f3D',
  [Networks.bsc]: '0xc41cB6d39741933f87e2a5781234E36361dE9EE1',
};

const dicepools = {
  [Networks.mainnet]:[
                        {
                          id: 'uFFYI',
                          token: '0x021576770CB3729716CCfb687afdB4c6bF720CB6',
                        },
                        {
                          id: 'FFYI',
                          token: '0xca76BAa777d749De63Ca044853D22D56bC70bb47',
                        },
                      ],
  [Networks.kovan]: [],
  [Networks.bsctest]: [],
  [Networks.bsc]: [],
};

var ourpools = [
  {
    id: 'uFFYI',
    pool: '0xd786646ebDF043309a880b6f2352f7399982F9e9',
    token: '0x021576770CB3729716CCfb687afdB4c6bF720CB6',
    decimals: 18,
  },
  {
    id: 'FFYI',
    pool: '0xA7913B56e299804603c02F8366A9a8fC5fe0c7B3',
    token: '0xca76BAa777d749De63Ca044853D22D56bC70bb47',
    decimals: 18,
  },
  {
    id: 'LINK',
    pool: '0xF4A32474280E8c8CbcfCE052944Bb69c4Bb47e21',
    token: '0x514910771AF9Ca656af840dff83E8264EcF986CA',
    decimals: 18,
  },
];

const etherscanUrls = {
  [Networks.mainnet]: 'https://etherscan.io',
  [Networks.kovan]: 'https://kovan.etherscan.io',
  [Networks.bsctest]: 'https://testnet.bscscan.com',
  [Networks.bsc]: 'https://bscscan.com',
};

const erc20ABI = [{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"showMeTheMoney","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"anonymous":false,"inputs":[{"indexed":true,"name":"_from","type":"address"},{"indexed":true,"name":"_to","type":"address"},{"indexed":false,"name":"_value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"_owner","type":"address"},{"indexed":true,"name":"_spender","type":"address"},{"indexed":false,"name":"_value","type":"uint256"}],"name":"Approval","type":"event"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"remaining","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"}],"name":"balanceOf","outputs":[{"name":"balance","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"}];
  

const factoryABI = [{"inputs": [],"stateMutability": "nonpayable","type": "constructor"},{"anonymous": false,"inputs": [{"indexed": true,"internalType": "address","name": "previousOwner","type": "address"},{"indexed": true,"internalType": "address","name": "newOwner","type": "address"}],"name": "OwnershipTransferred","type": "event"},{"inputs": [{"internalType": "address","name": "token","type": "address"}],"name": "allDicePools","outputs": [{"internalType": "address[]","name": "","type": "address[]"}],"stateMutability": "view","type": "function"},{"inputs": [],"name": "allTokens","outputs": [{"internalType": "address[]","name": "","type": "address[]"}],"stateMutability": "view","type": "function"},{"inputs": [{"internalType": "address","name": "_FFYIpool","type": "address"}],"name": "changeGOVpool","outputs": [],"stateMutability": "nonpayable","type": "function"},{"inputs": [{"internalType": "address","name": "","type": "address"},{"internalType": "uint256","name": "","type": "uint256"}],"name": "dicepools","outputs": [{"internalType": "address","name": "","type": "address"}],"stateMutability": "view","type": "function"},{"inputs": [{"internalType": "address","name": "_token","type": "address"},{"internalType": "uint256","name": "_minBet","type": "uint256"},{"internalType": "uint256","name": "liquidity","type": "uint256"},{"internalType": "uint256","name": "_jackpot","type": "uint256"},{"internalType": "uint256","name": "_jackpotpercent","type": "uint256"}],"name": "newDicePool","outputs": [],"stateMutability": "nonpayable","type": "function"},{"inputs": [],"name": "owner","outputs": [{"internalType": "address","name": "","type": "address"}],"stateMutability": "view","type": "function"},{"inputs": [],"name": "renounceOwnership","outputs": [],"stateMutability": "nonpayable","type": "function"},{"inputs": [{"internalType": "address","name": "token","type": "address"}],"name": "swap","outputs": [],"stateMutability": "nonpayable","type": "function"},{"inputs": [{"internalType": "address","name": "newOwner","type": "address"}],"name": "transferOwnership","outputs": [],"stateMutability": "nonpayable","type": "function"}];


function getPayout(betSize, winningChances) {
  return 100 / winningChances * betSize;
}

function tokenToWei(amount, decimals) {
  var weiAmout = BigInteger(Number(amount) * Math.pow(10, decimals)).toString();
  return toBN(weiAmout);
}

function tokenFromWei(weiamount, decimals) {
  var amount = toBN(weiamount) / toBN(Math.pow(10, decimals));
  return amount;
}


function cutHouseEdge(payout) {
  const houseEdge = 1 / 100.0;
  return payout * (1 - houseEdge);
}

function getProfit(betSize, winningChances) {
  if (winningChances === 0) {
    return 0;
  }
  const rawPayout = getPayout(betSize, winningChances);
  const netPayout = cutHouseEdge(rawPayout);

  return Math.max(netPayout - betSize, 0);
}


// Merges bet logs (LogBet) with bet results logs (LogResult).
function mergeLogs(logBetEvents, logResultEvents) {
  const findLogResultEventBylogBetEvent = logBetEvent => (
    logResultEvents.find(logResultEvent => (
      logResultEvent.returnValues.BetID === logBetEvent.returnValues.BetID
    ))
  );

  return logBetEvents.map(logBetEvent => ({
    logBetEvent,
    logResultEvent: findLogResultEventBylogBetEvent(logBetEvent),
  }));
}

class EtherollContract {
  constructor(web3, address) {
    this.web3 = web3;
    this.address = address;
    this.abi = etherollAbi;
    this.web3Contract = new web3.eth.Contract(etherollAbi, address);
    this.erc20ABI = erc20ABI;
    this.uffyi = '0x021576770CB3729716CCfb687afdB4c6bF720CB6';
    this.uffyiContract = new web3.eth.Contract(this.erc20ABI, this.uffyi);
    this.decimals = 18;
  }

  // callback(error, result)
  getTransactionLogs(callback) {
    this.web3.eth.getBlockNumber((error, blockNumber) => {
      if (error) {
        console.log(error);
      } else {
        const { address } = this;
        const toBlock = blockNumber;
        const fromBlock = toBlock - 100;
        const options = {
          address,
          fromBlock,
          toBlock,
        };
        this.web3Contract.getPastEvents('allEvents', options, callback);
      }
    });
  }

  // callback(error, result)
  getMergedTransactionLogs(callback) {
    this.getTransactionLogs((error, result) => {
      if (error) {
        console.log(error);
      } else {
        const logBetEvents = result.filter(evnt => evnt.event === 'LogBet');
        const logResultEvents = result.filter(evnt => evnt.event === 'LogResult');
        const mergedLogs = mergeLogs(logBetEvents, logResultEvents);
        callback(error, mergedLogs);
      }
    });
  }
}


export {
  EtherollContract, etherscanUrls, getProfit, mergeLogs, Networks, contractAddresses, factoryABI, factoryAddresses, erc20ABI, dicepools, ourpools, tokenToWei, tokenFromWei,
};
